import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { closeAnyModal } from '../../features/modals/modals.slice';
import { useAppDispatch } from '../useReduxToolkit';

/**
 * The hook is responsible for ensuring that modals are
 * automatically dismissed when the user navigates to a different page.
 */
export const useCloseModalOnRouteChange = (): void => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const handleRouteChangeStart = () => dispatch(closeAnyModal());

  useEffect(() => {
    router.events.on('routeChangeStart', handleRouteChangeStart);

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, [router]);
};
